(function () {
  const MAX_DISTANCE_KM = 250;

  /* ======================================================
   * SECTION FINDER (dynamic Shopify ids)
   * ====================================================== */
  function findSection(handle) {
    return document.querySelector(`[id$="__${handle}"]`);
  }

  const SECTIONS = {
    ratingBanner: () => findSection('ratingBanner'),
    online: () => findSection('online-option-cards'),
    showroom: () => findSection('showroom-list'),
    possibilites: () => findSection('showroom-possibilites-cards'),
    question: () => findSection('question-block-showroom'),
    faq: () => findSection('faq')
  };

  function setOrder(el, order) {
    if (el) el.style.order = order;
  }

  /* ======================================================
   * ORDER CONFIG
   * ====================================================== */
  function applyDefaultOrder() {
    setOrder(SECTIONS.ratingBanner(), 1);
    setOrder(SECTIONS.online(), 2);
    setOrder(SECTIONS.showroom(), 3);
    setOrder(SECTIONS.possibilites(), 4);
    setOrder(SECTIONS.question(), 5);
    setOrder(SECTIONS.faq(), 6);
  }

  function applyGrantedOrder() {
    let a = document.getElementById('showroomCount');
    a.style.display = 'none';
    setOrder(SECTIONS.ratingBanner(), 1);
    setOrder(SECTIONS.showroom(), 2);
    setOrder(SECTIONS.online(), 3);
    setOrder(SECTIONS.possibilites(), 4);
    setOrder(SECTIONS.question(), 5);
    setOrder(SECTIONS.faq(), 6);
  }
  function applyDeniedOrder() {

    let a = document.getElementById('allshowroomtitle');
    a.style.display = 'none';
    let b = document.getElementById('showroomCount');
    b.style.display = 'block';
    setOrder(SECTIONS.ratingBanner(), 1);
    setOrder(SECTIONS.showroom(), 2);
    setOrder(SECTIONS.online(), 3);
    setOrder(SECTIONS.possibilites(), 4);
    setOrder(SECTIONS.question(), 5);
    setOrder(SECTIONS.faq(), 6);
  }
  /* ======================================================
   * DISTANCE (TR approx)
   * ====================================================== */
  function getDistanceKm(lat1, lon1, lat2, lon2) {
    const dLat = lat2 - lat1;
    const dLon = lon2 - lon1;
    return Math.sqrt(dLat * dLat + dLon * dLon) * 97.16;
  }

  function findNearestShowroom(userLat, userLng, showrooms) {
    let nearest = null;
    let min = Infinity;

    showrooms.forEach((s) => {
      if (!s.latitude || !s.longitude) return;

      const d = getDistanceKm(userLat, userLng, s.latitude, s.longitude);
      if (d < min) {
        min = d;
        nearest = { ...s, distance: d };
      }
    });

    return nearest;
  }

  /* ======================================================
   * FEATURED SHOWROOM RENDER
   * ====================================================== */
function renderFeaturedShowroom(showroom) {
  const section = document.getElementById('shopify-section-showroom-list');
  if (!section) return;

  const featuredWrapper = section.querySelector('[data-featured-showroom]');
  const featuredContainer = section.querySelector('[data-featured-container]');
  if (!featuredWrapper || !featuredContainer) return;

  const original = section.querySelector(
    `[data-showroom][data-lat="${showroom.latitude}"][data-lng="${showroom.longitude}"]`
  );
  if (!original) return;

  // 🔗 A etiketi
  const wrapperLink = document.createElement('a');
  wrapperLink.href = `/pages/showroom-detail?handle=${showroom.slug}`;
  wrapperLink.rel = 'preload';

  // 🎴 Kartı clone et
  const cloned = original.cloneNode(true);
  // cloned.classList.add('showroom-card--featured');

  // ✅ KARTI A'NIN İÇİNE KOY
  wrapperLink.appendChild(cloned);

  // 🧹 Container temizle
  featuredContainer.innerHTML = '';

  // ✅ A etiketi container’a girsin
  featuredContainer.appendChild(wrapperLink);

  // 👀 Göster
  featuredWrapper.hidden = false;
}


  function clearFeaturedShowroom() {
    const el = document.querySelector('[data-featured-showroom]');
    if (el) el.hidden = true;
  }


  /* ======================================================
   * STATE + EVENTS
   * ====================================================== */
  function publishMatchResult(hasMatch, nearest) {
    window.__SHOWROOM_MATCH_RESULT__ = { hasMatch, nearest };

    document.dispatchEvent(
      new CustomEvent('user:showroom:match-result', {
        detail: { hasMatch, nearest }
      })
    );
  }

  let handled = false;

  function handleLocationReady(detail) {
    if (handled) return;
    handled = true;

    if (!detail || detail.permission !== 'granted') {
      publishMatchResult(false, null);
      return;
    }

    const showrooms = window.__SHOWROOM_METAOBJECTS__ || [];
    const nearest = findNearestShowroom(
      detail.latitude,
      detail.longitude,
      showrooms
    );

    const hasMatch = nearest && nearest.distance <= MAX_DISTANCE_KM;
    publishMatchResult(hasMatch, nearest);
  }

  /* ======================================================
   * ORDER + FEATURE SYNC
   * ====================================================== */
  function syncUI() {
    const data =
      window.__USER_LOCATION__ ||
      JSON.parse(localStorage.getItem('user_location') || '{}');

    if (data.permission === 'granted') {
      applyGrantedOrder();

      if (window.__SHOWROOM_MATCH_RESULT__?.nearest) {
        renderFeaturedShowroom(window.__SHOWROOM_MATCH_RESULT__.nearest);
      }
    } else {
      applyDefaultOrder();
      clearFeaturedShowroom();
    }
  }

  /* ======================================================
   * INIT
   * ====================================================== */
  document.addEventListener('DOMContentLoaded', () => {
    applyDefaultOrder(); // CLS önleme
    syncUI();
    const permission = window.__USER_LOCATION__?.permission;

    if (permission === 'denied') {
      applyDeniedOrder();
      clearFeaturedShowroom();
      return;
    }
    if (
      window.__USER_LOCATION__ &&
      window.__USER_LOCATION__.permission === 'granted'
    ) {
      handleLocationReady(window.__USER_LOCATION__);
    }
  });

  

  document.addEventListener('user:location:ready', (e) => {
    handleLocationReady(e.detail);
    syncUI();
  });

  document.addEventListener('user:showroom:match-result', (e) => {
    const { hasMatch, nearest } = e.detail;
    const permission = window.__USER_LOCATION__?.permission;

    requestAnimationFrame(() => {
      if (permission === 'denied') {
        applyDeniedOrder();
        clearFeaturedShowroom();
        return;
      }
      if (hasMatch && nearest) {
        applyGrantedOrder();
        renderFeaturedShowroom(nearest);
      } else {
        applyDefaultOrder();
        clearFeaturedShowroom();
      }
    });
  });
})();

// document.addEventListener('user:showroom:match-result', (e) => {
//   const { hasMatch, nearest } = e.detail;

//   const permission = window.__USER_LOCATION__?.permission;

//   requestAnimationFrame(() => {
//     if (permission === 'denied') {
//       applyDeniedOrder();
//       clearFeaturedShowroom();
//       return;
//     }

//     if (hasMatch) {
//       applyGrantedOrder();
//     } else {
//       applyDefaultOrder();
//     }
//   });
  

//   if (hasMatch && nearest) {
//     renderFeaturedShowroom(nearest);
//   } else {
//     clearFeaturedShowroom();
//   }
// });

function setCookie(name, value, days = 30) {
  const expires = new Date(Date.now() + days * 864e5).toUTCString();
  document.cookie =
    name + '=' + encodeURIComponent(value) +
    '; expires=' + expires +
    '; path=/; SameSite=Lax';
}

function getCookie(name) {
  return document.cookie
    .split('; ')
    .find(row => row.startsWith(name + '='))
    ?.split('=')[1];
}

function deleteCookie(name) {
  document.cookie =
    name + '=; expires=Thu, 01 Jan 1970 00:00:00 UTC; path=/;';
}
